import { Component, OnDestroy } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ReplaySubject } from 'rxjs';
import { ENTER } from '@angular/cdk/keycodes';
import { environment } from '@deltager/organizers/admin/environments/environment';

@Component({
  template: '',
})
export abstract class BaseComponent implements OnDestroy {
  public readonly DefaultListOption = -1;
  public readonly FullDayMins = 1440;

  public readonly exportPdfIcon = `${environment.staticAssetLocation}/svg/PDF_file_icon.svg`;
  public readonly exportExcelIcon = `${environment.staticAssetLocation}/svg/excel_icon.svg`;

  protected destroyed$: ReplaySubject<boolean> = new ReplaySubject();

  protected completeSubject() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngOnDestroy(): void {
    this.completeSubject();
  }

  public handleEnterKey(event: any): boolean {
    if (event.keyCode == ENTER) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  public changeCtrlVisibility(ctrl: AbstractControl, enable: boolean): void {
    if (!ctrl) {
      return;
    }

    if (enable && ctrl.disabled) {
      ctrl.enable();
    } else if (!enable && ctrl.enabled) {
      ctrl.disable();
    }
  }
}
